import { formatThousandUnitDefaultTwo, keepTwoOrLine, keepTwoAndWanOrLine } from '@/utils/utils';
import circle_spin from '../../imgs/circle_spin.png';

export const getChartOption = (pieLegendData?: any[], energyType?: 'energy' | 'cost') => {
  const unit = energyType === 'cost' ? '元' : 'kWh';
  return {
    color: ['#FF4D4F', '#FFCB47', '#2D8DFF', '#16DD8E', '#ABD335'],
    legend: {
      show: false,
    },
    tooltip: {
      trigger: 'item',
      confine: true,
      formatter: (params: any) => {
        const { data } = params;
        return `
      <div>
        <div>${data?.name}：${keepTwoAndWanOrLine(data?.value)}${unit}</div>
        <div>占比：${keepTwoOrLine(data?.rate)}%</div>
      </div>
    `;
      },
    },
    graphic: {
      elements: [
        {
          type: 'image',
          style: {
            image: circle_spin,
            x: 60,
            y: 40,
            width: 90,
            height: 90,
          },
          keyframeAnimation: [
            {
              duration: 50000,
              loop: true,
              easing: 'linear',
              keyframes: [
                {
                  percent: 0,
                  rotation: 0,
                  transition: ['rotation'],
                },
                {
                  percent: 1,
                  rotation: 360,
                  transition: ['rotation'],
                },
              ],
            },
          ],
          origin: [105, 85],
          tooltip: {
            show: false,
          },
        },
      ],
    },
    series: [
      {
        type: 'pie',
        name: `总计`,
        percentPrecision: 5,
        minAngle: 2,
        padAngle: 1,
        radius: [52, 60],
        left: 72,
        top: 52,
        width: 66,
        height: 66,
        label: {
          show: false,
        },
        data: pieLegendData,
        showEmptyCircle: false,
      },
      {
        showEmptyCircle: false,
        data: pieLegendData,
        type: 'pie',
        percentPrecision: 5,
        padAngle: 1,
        minAngle: 2,
        left: 72,
        top: 52,
        name: `总计`,
        radius: [60, 76],
        width: 66,
        height: 66,
        emphasis: {
          disabled: true,
        },
        label: {
          show: false,
        },
        itemStyle: {
          opacity: 0.2,
        },
      },
    ],
  };
};

export interface PieLegendItem {
  name: string;
  value?: number;
  rate?: number;
  color: string;
}
